const Flag = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <path
        data-name="Icon metro-flag"
        d="M2.571 1.928h2.5v20h-2.5zm16.25 12.559a6.45 6.45 0 0 0 3.75-.967v-10a6.45 6.45 0 0 1-3.75.967 6.45 6.45 0 0 1-3.75-.967v10a6.45 6.45 0 0 0 3.75.967zM14.446 2.563a10.029 10.029 0 0 0-3.75-.635 8.491 8.491 0 0 0-4.375.967v10a8.491 8.491 0 0 1 4.375-.967 10.029 10.029 0 0 1 3.75.635v-10z"
        transform="translate(-2.571 -1.928)"
      />
    </svg>
  );
};

export default Flag;
